import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AnalyticsService} from '../../../analytics/analytics.service';
import {Analytics} from '../../../name.annotation';

@Component({
  selector: 'app-user-document',
  templateUrl: './user-document.component.html',
  styleUrls: ['./user-document.component.scss']
})
@Analytics('user_document')
export class UserDocumentComponent implements OnInit {
  course: any;
  userDocument: any;

  constructor(private route: ActivatedRoute, private analyticsService: AnalyticsService) {
  }

  ngOnInit(): void {
    this.course = this.route.snapshot.data.course;
    this.userDocument = this.route.snapshot.data.userDocument;

    if (this.course) {
      this.analyticsService.userDocumentViewedByCourse(this.course, this.userDocument.pspdfkitId);
    } else {
      this.analyticsService.userDocumentViewed(this.userDocument.pspdfkitId);
    }
  }

}
